var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-excel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.57,
    height: 53.975,
    viewBox: "0 0 57.57 53.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4320",
    "data-name": "Path 4320",
    d: "M282.986,119.591H257.8a1.8,1.8,0,0,1-1.8-1.8V81.81a1.8,1.8,0,0,1,1.8-1.8h25.187a1.8,1.8,0,0,1,1.8,1.8v35.981A1.8,1.8,0,0,1,282.986,119.591Z",
    transform: "translate(-227.215 -72.812)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160499",
    "data-name": "Group 160499",
    transform: "translate(28.785 14.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4321",
    "data-name": "Path 4321",
    d: "M265,147.609h-7.2a1.8,1.8,0,0,1,0-3.6H265a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-256 -144.011)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4322",
    "data-name": "Path 4322",
    d: "M265,211.609h-7.2a1.8,1.8,0,0,1,0-3.6H265a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-256 -200.815)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4323",
    "data-name": "Path 4323",
    d: "M265,275.609h-7.2a1.8,1.8,0,0,1,0-3.6H265a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-256 -257.618)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4324",
    "data-name": "Path 4324",
    d: "M265,339.609h-7.2a1.8,1.8,0,0,1,0-3.6H265a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-256 -314.422)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4325",
    "data-name": "Path 4325",
    d: "M389.4,147.609h-3.6a1.8,1.8,0,0,1,0-3.6h3.6a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-369.607 -144.011)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4326",
    "data-name": "Path 4326",
    d: "M389.4,211.609h-3.6a1.8,1.8,0,0,1,0-3.6h3.6a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-369.607 -200.815)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4327",
    "data-name": "Path 4327",
    d: "M389.4,275.609h-3.6a1.8,1.8,0,0,1,0-3.6h3.6a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-369.607 -257.618)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4328",
    "data-name": "Path 4328",
    d: "M389.4,339.609h-3.6a1.8,1.8,0,0,1,0-3.6h3.6a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-369.607 -314.422)",
    fill: "#388e3c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4329",
    "data-name": "Path 4329",
    d: "M31.732,16.406a1.768,1.768,0,0,0-1.479-.381l-28.785,5.4A1.794,1.794,0,0,0,0,23.188v39.58a1.8,1.8,0,0,0,1.468,1.767l28.785,5.4a1.693,1.693,0,0,0,.331.032,1.8,1.8,0,0,0,1.8-1.8V17.791A1.794,1.794,0,0,0,31.732,16.406Z",
    transform: "translate(0 -15.989)",
    fill: "#2e7d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4330",
    "data-name": "Path 4330",
    d: "M95.731,176.832l-5.689-6.5,5.753-7.4a1.8,1.8,0,0,0-2.839-2.213l-5.329,6.851-4.49-5.131a1.8,1.8,0,1,0-2.706,2.368l4.947,5.656-5.016,6.448a1.8,1.8,0,0,0,2.843,2.209l4.588-5.9,5.232,5.977a1.8,1.8,0,1,0,2.706-2.364Z",
    transform: "translate(-70.99 -143.831)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExcel);
export default __webpack_public_path__ + "static/media/ic-excel.c7ade17e87cfb9efc997f4b13a1075a0.svg";
export { ForwardRef as ReactComponent };